import type { FilterChip, Lookups } from "../../types";
import { buildRangeLabel } from "../../utils/buildRangeLabel";
import type { ItSpendSlice } from "./slice";

export function getChips(
  slice: ItSpendSlice,
  setSlice: (s: ItSpendSlice) => void,
  lookups?: Lookups
): FilterChip[] {
  const spendRowsWithIndex = slice.rows
    .map((row, index) => ({ row, index }))
    .filter(({ row }) => !!row.categoryId);

  if (spendRowsWithIndex.length === 0) return [];

  // Build categories map from lookups
  const spendCategoriesById = lookups?.spendCategories
    ? new Map(lookups.spendCategories.map((c) => [c.id, c.name]))
    : undefined;

  return spendRowsWithIndex.map(({ row, index }) => {
    const categoryLabel =
      spendCategoriesById?.get(row.categoryId as string) ??
      (row.categoryId as string);
    const rangeLabel = buildRangeLabel(row.min, row.max, {
      isCurrency: true,
    });
    const label = rangeLabel
      ? `${categoryLabel}: ${rangeLabel}`
      : categoryLabel;

    return {
      id: `itSpend-${row.categoryId}-${index}`,
      label: `IT Spend: ${label}`,
      filterKey: "itSpend" as const,
      onRemove: () => {
        const nextRows = slice.rows.filter((_, i) => i !== index);
        setSlice({ rows: nextRows.length > 0 ? nextRows : [{}] });
      },
    };
  });
}

export function getCount(slice: ItSpendSlice): number {
  return slice.rows.filter((r) => !!r.categoryId).length;
}
